import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassStudentStoreModel } from './class-student.model';

export type ClassStudentState = EntityState<ClassStudentStoreModel>;

@Injectable({ providedIn: 'root' })
export class ClassStudentStore extends EntityStore<ClassStudentState, ClassStudentStoreModel, 'id'> {
  constructor() {
    super({
      name: 'class-students',
      idKey: 'id',
    });
  }
}
